<template>
  <div class="dashboard-common-page">
    <div class="dashboard-common-page-block">
      <stats :stats="stats" />
      <calendar :tasks="tasks" :holidays="holidays" />
      <stickers style="margin-top: 16px" :stickers="stickers" />
    </div>
    <div class="dashboard-common-page-block">
      <div class="dashboard-tasks">
        <div class="ms-container-header">
          <icon size="16" type="md-list" />
          Задачи
        </div>
        <div class="dashboard-tasks-container">
          <template v-if="tasks.length">
            <tasks-list :tasks="filteredTasks" />
            <div
              v-if="tasks.length > 20"
              @click="showAll = !showAll"
              class="dashboard-common-page__show-all ms-link"
            >
              {{ showAll ? "Скрыть все" : `Показать все задачи (${tasks.length})` }}
            </div>
          </template>
          <div v-else class="ms-nodata ms-help">
            Актульные задачи по Вашему запросу отсутствуют
          </div>
        </div>
      </div>
      <back-top />
    </div>
  </div>
</template>

<script>
import Calendar from '@/components/dashboard/common-page/calendar'
import Stickers from '@/components/dashboard/common-page/stickers'
import Stats from '@/components/dashboard/common-page/stats'
import TasksList from '@/components/dashboard/common-page/tasks-list'

export default {
  props: ['stickers', 'tasks', 'stats', 'holidays'],
  components: {
    Calendar,
    Stickers,
    Stats,
    TasksList
  },
  data () {
    return {
      showAll: false
    }
  },
  computed: {
    filteredTasks () {
      if (this.showAll) {
        return this.tasks
      }

      return this.tasks.slice(0, 20)
    }
  }
}
</script>

<style lang="less">
.dashboard-common-page {
  display: flex;
  width: 100%;

  &-block {
    width: 50%;
    flex-shrink: 0;

    &:not(:first-child) {
      margin-left: 16px;
    }
  }

  &__show-all {
    margin-top: 16px;
    text-align: center;
    cursor: pointer;
    font-weight: bold;
  }
}
</style>
